(function(){
'use strict';

angular.module('classy').component('panelSectionBody', {
  template: '<div class="panel__section-body" role="group" aria-labelledby="attendee" data-ng-transclude></div>',
  transclude: true
});
})();